import React, { useState, useEffect } from 'react';
export const ResizedImage = ({ src }) => {
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const image = new Image();
    image.src = src;
    image.onload = () => {
      const scaleFactor = Math.min(200 / image.width, 45 / image.height);
      const width = image.width * scaleFactor;
      const height = image.height * scaleFactor;

      setImageDimensions({ width, height });
    };
  }, [src]);

  return (
    <img
      src={src}
      width={imageDimensions.width}
      height={imageDimensions.height}
      style={{ alignSelf: 'flex-start' }} 
    />
  );
};
